import Apollo from '@adoratorio/apollo';
import engine from './engine';

const apollo = {
  ref: null,

  init() {
    this.ref = new Apollo({
      cursor: document.querySelector('.cursor'),
      easing: {
        mode: Apollo.EASING.CUBIC,
        duration: 600,
      },
      props: [],
      targets: [],
      aion: engine,
      render: false,
      initialPosition: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2,
      },
    });
  },
};

export default apollo;
